
import React from "react"
import SidePlace from "./useStateF"
import Icon from "./images/icon-complete.svg"
import "./App.css"
import { useState } from "react";

function App(e) {
  const [name, setName] = useState("James Rachael");
  const [cardNumber, setCardNumber] = useState(0);
  const [expDate, setexpDate] = useState(0);
  const [expDateD, setexpDateD] = useState("00");
  const [cvc, setCvC] = useState("000")
  const [emptyValue, setEmptyValue] = useState("")



  const handleSubmit = (event) => {
    event.preventDefault();
    const fromField = document.querySelector(".Form-field")
    const successMessage = document.querySelector(".sucess")
    if(cvc === "000"){
      setEmptyValue("Values Cant Be Blank")
    }else{
      setEmptyValue("")
      fromField.classList.add("sucess")
      successMessage.classList.add("show")

    }
   
  }


  return(
    <div className="App">
<div>
<SidePlace cardNumber={cardNumber} setCardNumber={setCardNumber} name={name} setName={setName} expDate={expDate} expDateD={expDateD} cvc={cvc}  />
</div>
<div >
<form onSubmit={handleSubmit} className="Form-field" >
     <div>
     <label>Enter your name:</label>
     </div>
      <input 
        type="text" 
        name="username" 
        value={name.name} 
        onChange={(e) => setName(e.target.value)}
      />
      <p style={{color:"red"}}>{emptyValue}</p>
     
      <div><label>Card Number:</label></div>
        <input maxLength={16}
          type="text" 
          name="age" 
          value={cardNumber} 
          onChange={(e) => setCardNumber(e.target.value)}
        />
            <p style={{color:"red"}}>{emptyValue}</p>
  
        <div><label>Exp Date (MM):</label></div>
        <input maxLength={2}
          type="text" 
          name="age" 
          value={expDate.expDate} 
          onChange={(e) => setexpDate(e.target.value)}
        />
              <p style={{color:"red"}}>{emptyValue}</p>

        <div><label>Exp Date (DD):</label></div>
        <input maxLength={2}
          type="text" 
          name="month" 
          value={expDateD.expDateD} 
          onChange={(e) => setexpDateD(e.target.value)}
        />
              <p style={{color:"red"}}>{emptyValue}</p>

        <div><label>CVC:</label></div>
        <input maxLength={3}
          type="text" 
          name="date" 
          value={cvc.cvc} 
          onChange={(e) => setCvC(e.target.value)} 
        />
              <p style={{color:"red"}}>{emptyValue}</p>

        
        <div className="submit">
        <input type="submit" />
        </div>
    </form>
    <div className="sucess">
        <img src={Icon} alt="" />
        <p>Thank You We have Added Your Card Details</p>
        <a href="../public/index.html"><button>Continue</button></a>
    </div>
</div>

    </div>
    
  )
}

export default App